// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Nachunternehmer. Every selector is scoped to .subcontractors-page (dialogs get it as
   rootClassName because they render outside the page) or to the badge's own .sc-light class,
   which also appears on accounting pages. */

.subcontractors-page .sc-full {
  width: 100%;
}

.subcontractors-page .sc-num {
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.subcontractors-page .sc-small {
  font-size: 13px;
  color: var(--ds-text-muted);
}

.subcontractors-page .sc-break {
  overflow-wrap: anywhere;
}

.subcontractors-page .sc-empty-text {
  max-width: 520px;
  margin-inline: auto;
}

/* ---- Traffic light ---- */
.sc-light {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.sc-light .sc-dot {
  inline-size: 8px;
  block-size: 8px;
  border-radius: 50%;
  background: currentColor;
  flex: none;
}

.subcontractors-page .sc-warning-list,
.ant-alert .sc-warning-list {
  margin: 0;
  padding-inline-start: 18px;
}

/* ---- Detail header ---- */
.subcontractors-page .sc-header {
  display: flex;
  align-items: center;
  gap: var(--ds-space-2);
  flex-wrap: wrap;
}

.subcontractors-page .sc-header-title {
  display: flex;
  align-items: center;
  gap: var(--ds-space-2);
  flex: 1 1 0;
  min-width: 0;
  flex-wrap: wrap;
}

.subcontractors-page .sc-header-title h4 {
  margin: 0;
  overflow-wrap: anywhere;
}

/* ---- Documents per type ---- */
.subcontractors-page .sc-type {
  inline-size: 100%;
}

.subcontractors-page .sc-type-head {
  display: flex;
  align-items: center;
  gap: var(--ds-space-2);
  flex-wrap: wrap;
}

.subcontractors-page .sc-type-title {
  flex: 1 1 220px;
  min-width: 0;
}

.subcontractors-page .sc-doc {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--ds-space-2);
  flex-wrap: wrap;
  margin-top: var(--ds-space-2);
  padding: var(--ds-space-2) var(--ds-space-3);
  border: 1px solid var(--ds-border);
  border-radius: var(--ds-radius-md, 10px);
  background: var(--ds-surface);
}

.subcontractors-page .sc-doc-archived {
  opacity: 0.6;
}

.subcontractors-page .sc-doc-main {
  display: flex;
  align-items: center;
  gap: var(--ds-space-2);
  flex-wrap: wrap;
  min-width: 0;
}

/* ---- Order dialog ---- */
.subcontractors-page .sc-line {
  border: 1px solid var(--ds-border);
  border-radius: var(--ds-radius-md, 10px);
  padding: var(--ds-space-3);
  margin-bottom: var(--ds-space-3);
}

.subcontractors-page .sc-line-actions {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  padding-bottom: var(--ds-space-3);
}

/* ---- Public upload page ---- */
.subcontractors-page.sc-public {
  min-height: 100vh;
  background: var(--ds-bg);
  padding: var(--ds-space-4) var(--ds-space-3);
}

.subcontractors-page .sc-public-inner {
  max-width: 640px;
  margin-inline: auto;
}

.subcontractors-page .sc-public-company {
  display: flex;
  align-items: center;
  gap: var(--ds-space-2);
  margin-bottom: var(--ds-space-3);
}

.subcontractors-page .sc-public-company img {
  max-height: 40px;
  max-width: 160px;
  object-fit: contain;
}
`, "",{"version":3,"sources":["webpack://./src/serviceProvider/components/subcontractors/subcontractors.css"],"names":[],"mappings":"AAAA;;4CAE4C;;AAE5C;EACE,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,wBAAwB;EACxB,UAAU;AACZ;;AAEA;;EAEE,SAAS;EACT,0BAA0B;AAC5B;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,uBAAuB;AACzB;;AAEA,iCAAiC;AACjC;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,eAAe;EACf,6BAA6B;EAC7B,4CAA4C;EAC5C,kCAAkC;EAClC,wCAAwC;EACxC,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,kCAAkC;EAClC,wCAAwC;EACxC,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA,iCAAiC;AACjC;EACE,iBAAiB;EACjB,wBAAwB;EACxB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":["/* Nachunternehmer. Every selector is scoped to .subcontractors-page (dialogs get it as\n   rootClassName because they render outside the page) or to the badge's own .sc-light class,\n   which also appears on accounting pages. */\n\n.subcontractors-page .sc-full {\n  width: 100%;\n}\n\n.subcontractors-page .sc-num {\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n.subcontractors-page .sc-small {\n  font-size: 13px;\n  color: var(--ds-text-muted);\n}\n\n.subcontractors-page .sc-break {\n  overflow-wrap: anywhere;\n}\n\n.subcontractors-page .sc-empty-text {\n  max-width: 520px;\n  margin-inline: auto;\n}\n\n/* ---- Traffic light ---- */\n.sc-light {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.sc-light .sc-dot {\n  inline-size: 8px;\n  block-size: 8px;\n  border-radius: 50%;\n  background: currentColor;\n  flex: none;\n}\n\n.subcontractors-page .sc-warning-list,\n.ant-alert .sc-warning-list {\n  margin: 0;\n  padding-inline-start: 18px;\n}\n\n/* ---- Detail header ---- */\n.subcontractors-page .sc-header {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n  flex-wrap: wrap;\n}\n\n.subcontractors-page .sc-header-title {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n  flex: 1 1 0;\n  min-width: 0;\n  flex-wrap: wrap;\n}\n\n.subcontractors-page .sc-header-title h4 {\n  margin: 0;\n  overflow-wrap: anywhere;\n}\n\n/* ---- Documents per type ---- */\n.subcontractors-page .sc-type {\n  inline-size: 100%;\n}\n\n.subcontractors-page .sc-type-head {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n  flex-wrap: wrap;\n}\n\n.subcontractors-page .sc-type-title {\n  flex: 1 1 220px;\n  min-width: 0;\n}\n\n.subcontractors-page .sc-doc {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--ds-space-2);\n  flex-wrap: wrap;\n  margin-top: var(--ds-space-2);\n  padding: var(--ds-space-2) var(--ds-space-3);\n  border: 1px solid var(--ds-border);\n  border-radius: var(--ds-radius-md, 10px);\n  background: var(--ds-surface);\n}\n\n.subcontractors-page .sc-doc-archived {\n  opacity: 0.6;\n}\n\n.subcontractors-page .sc-doc-main {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n  flex-wrap: wrap;\n  min-width: 0;\n}\n\n/* ---- Order dialog ---- */\n.subcontractors-page .sc-line {\n  border: 1px solid var(--ds-border);\n  border-radius: var(--ds-radius-md, 10px);\n  padding: var(--ds-space-3);\n  margin-bottom: var(--ds-space-3);\n}\n\n.subcontractors-page .sc-line-actions {\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-end;\n  padding-bottom: var(--ds-space-3);\n}\n\n/* ---- Public upload page ---- */\n.subcontractors-page.sc-public {\n  min-height: 100vh;\n  background: var(--ds-bg);\n  padding: var(--ds-space-4) var(--ds-space-3);\n}\n\n.subcontractors-page .sc-public-inner {\n  max-width: 640px;\n  margin-inline: auto;\n}\n\n.subcontractors-page .sc-public-company {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n  margin-bottom: var(--ds-space-3);\n}\n\n.subcontractors-page .sc-public-company img {\n  max-height: 40px;\n  max-width: 160px;\n  object-fit: contain;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
